<script setup lang="ts">
</script>

<template>
  <UIcon
    name="i-mingcute-leaf-2-fill"
    class="text-2xl text-indigo-500 dark:text-indigo-300" />
</template>
